// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BackgroundItem__blur-item-a72027 {
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 12px;
  margin-inline-end: 8px;
  cursor: pointer;
  background-color: var(--addition-50_10);
}

.BackgroundItem__blur-item-a72027:hover {
  background-color: var(--addition-50_15);
}

.BackgroundItem__blur-item-a72027:active {
  background-color: var(--addition-50_20);
}

.BackgroundItem__blur-item-a72027:focus {
  background-color: var(--addition-50_15);
}

.BackgroundItem__blur-item-a72027 svg {
  fill: var(--addition-50);
}

.BackgroundItem__blur-item-active-f1d0f4 {
  border: 2px solid var(--addition-50);
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/Shared/AnimatedBackgroundPanel/components/BackgroundItem/BackgroundItem.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,uCAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,uCAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,oCAAA;AACF","sourcesContent":[".blur-item {\n  width: 76px;\n  height: 76px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  border-radius: 12px;\n  margin-inline-end: 8px;\n  cursor: pointer;\n  background-color: var(--addition-50_10);\n}\n\n.blur-item:hover {\n  background-color: var(--addition-50_15);\n}\n\n.blur-item:active {\n  background-color: var(--addition-50_20);\n}\n\n.blur-item:focus {\n  background-color: var(--addition-50_15);\n}\n\n.blur-item svg {\n  fill: var(--addition-50);\n}\n\n.blur-item-active {\n  border: 2px solid var(--addition-50);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blur-item": `BackgroundItem__blur-item-a72027`,
	"blurItem": `BackgroundItem__blur-item-a72027`,
	"blur-item-active": `BackgroundItem__blur-item-active-f1d0f4`,
	"blurItemActive": `BackgroundItem__blur-item-active-f1d0f4`
};
module.exports = ___CSS_LOADER_EXPORT___;
